import React from 'react';
import { genericMemo } from '@direct-frontend/stdlib';

import { cn } from '../../lib/css/className/className';
import { Cell } from '../Cell';
import { TestProps } from '../../internal/types/testTypes';
import { CellProps } from '../Cell';
import { CellSizeContext } from '../Table/context';
import './StubCell.css';
import { Stub } from '../Stub';
import { VStack } from '../Stack';

const STUB_TITLE_WIDTH = 40;

const fixedWidthStubSize = {
    s: {
        title: STUB_TITLE_WIDTH,
        caption: STUB_TITLE_WIDTH - 8,
    },
    m: {
        title: STUB_TITLE_WIDTH,
        caption: STUB_TITLE_WIDTH - 12,
    },
    l: {
        title: STUB_TITLE_WIDTH,
        caption: STUB_TITLE_WIDTH - 16,
    },
};

const cls = cn('StubCell');

export type StubCellProps = TestProps &
    Pick<
        CellProps,
        | 'topPadding'
        | 'bottomPadding'
        | 'rightPadding'
        | 'leftPadding'
        | 'size'
        | 'isGrowable'
        | 'className'
        | 'withBorder'
        | 'borderColor'
        | 'borderStyle'
    > & {
        /** добавляет еще один Stub снизу основного, эмулириующий подгрузку caption текста */
        withCaption?: boolean;
    };

export const StubCell = genericMemo(function StubCell(props: StubCellProps) {
    const {
        'data-testid': dataTestId = 'StubCell',
        size: cellSize = 'm',
        isGrowable = true,
        topPadding = true,
        bottomPadding = true,
        leftPadding = true,
        rightPadding = true,
        withCaption = false,
        className,
        ...cellProps
    } = props;

    const tableSize = React.useContext(CellSizeContext);

    const size = tableSize ?? cellSize;

    return (
        <Cell
            {...cellProps}
            data-testid={dataTestId}
            isGrowable={isGrowable}
            className={cls(
                '',
                {
                    size,
                    topPadding,
                    bottomPadding,
                    leftPadding,
                    rightPadding,
                },
                [className],
            )}
        >
            <VStack gap="4" className={cls('wrapper')}>
                <Stub height={20} width={!isGrowable ? fixedWidthStubSize[size].title : undefined} />
                {withCaption && (
                    <Stub
                        height={16}
                        width={!isGrowable ? fixedWidthStubSize[size].caption : undefined}
                        className={cls('StubCaption', {
                            grow: isGrowable,
                            size,
                        })}
                    />
                )}
            </VStack>
        </Cell>
    );
});
